import React, { useEffect, useState } from "react";//added approval button,modal and included its functions
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  channelPartnerList,
  channelPartnerStatusUpdate,
  channelPartnerApprove
} from "reduxStore/action/channelPartnerAction";
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Pagination from "component/common/Pagination";
import usePage from "utils/usePage";
import moment from "moment";
import Button from "component/Button";

const AgentList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null); 
  const [page, setPage] = usePage();
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const channelPartnerListSelector = useSelector(
    (state) => state?.channelPartner
  );
  const params = new URLSearchParams(window.location.search);
  const cp_user_id = params.get("channelpartner");

  const { view,isAdmin } = usePermission({
    create: "add_channelpartner",
    view: "view_channelpartner",
  });
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    cp_name: "",
    limit: "",
    offset: "",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  useEffect(() => {
    dispatch(
      channelPartnerList({
        user_type: 2,
        limit: 10,
        offset: 0,
        cp_user_id: cp_user_id,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const { response = null, create = false } = channelPartnerListSelector;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        setchannelPartnerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setchannelPartnerList([]);
    }
  }, [channelPartnerListSelector]);

  // const handleUserStatus = (data) => {
  //   dispatch(channelPartnerStatusUpdate(data));
  // };

  const handleUserStatus = (data) => {
    dispatch(channelPartnerStatusUpdate(data)).then(() => {
      // Re-fetch the channel partner list after the status update is successful
      dispatch(
        channelPartnerList({
          user_type: 2,
          limit: 10,
          offset: 0,
          cp_user_id: cp_user_id,
        })
      );
    });
  };
  

  const handleApprove = (itemId) => {
    const data = { cp_id: itemId, approved: true }; // Create the object to send
    dispatch(channelPartnerApprove(data)); // Pass data to the action
    setModalOpen(false); // Close modal after approval
  };

  const openApprovalModal = (itemId) => {
    setSelectedItemId(itemId);
    setModalOpen(true); // Open modal when Approve button is clicked
  };

  // const filterDetail = () => {
  //   dispatch(
  //     channelPartnerFilter({
  //       limit: 10,
  //       offset: 0,
  //       user_type: 2,
  //       cp_user_id: cp_user_id,
  //       start_date: form.start_date,
  //       end_date: form.end_date,
  //       cp_name: form.cp_name,
  //     })
  //   );
  //   setPage(0);
  // };

  // const filterReset = () => {
  //   setForm({
  //     start_date: "",
  //     end_date: "",
  //     cp_name: "",
  //   });
  //   dispatch(
  //     channelPartnerList({
  //       user_type: 2,
  //       limit: 10,
  //       offset: 0,
  //       cp_user_id: cp_user_id,
  //     }),
  //     setPage(0)
  //   );
  // };

  // const handleInputField = (e) => {
  //   const nextFormState = {
  //     ...form,
  //     [e.target.name]: e.target.value,
  //   };
  //   setForm(nextFormState);
  // };
  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      channelPartnerList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        cp_name: form.cp_name,
        cp_user_id: cp_user_id,
        user_type: 2,
      })
    );
  };
  useEffect(() => {
    seo({
      title: "Agent Listing",
      metaDescription: "Agnet listing",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.cpAgnet}
        titleactive={strings.agentListing}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            {/* <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              max={form.end_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByName}
                          </span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="cp_name"
                              value={form.cp_name}
                              onChange={handleInputField}
                              placeholder={strings.searchName}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-12 pt-3">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning  mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfAgent}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.agentName}</th>
                          <th scope="col">{strings.createdDate}</th>
                          <th scope="col">{strings.agentCode}</th>
                          <th scope="col">{strings.visits}</th>
                          <th scope="col">{strings.noOfSiteVisit}</th>
                          <th scope="col">{strings.noOfClosingLead}</th>
                          <th scope="col">{strings.closingPercentage}</th>
                          {/* <th scope="col">{strings.approved}</th> */}
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {getchannelPartnerList?.length > 0 ? (
                          getchannelPartnerList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.agent_name}</td>
                                <td>
                                  {item.createdDate
                                    ? moment(item.createdDate).format(
                                      "DD-MM-yyyy hh:mm a"
                                    )
                                    : "-"}
                                </td>
                                <td>{item.agent_code}</td>
                                <td>{item.total_visit}</td>
                                <td>{item.total_site_visit}</td>
                                <td>{item.total_closing_lead}</td>
                                <td>
                                  {item.total_closing_percentage
                                    ? Number(
                                      item.total_closing_percentage.replace(
                                        "%",
                                        ""
                                      )
                                    ).toFixed(2) + "%"
                                    : "-"}
                                </td>
                                {/* <td>
                                  {item.approved ? (
                                    "Approved"
                                  ) : (
                                    <Button
                                    className="btn btn-success"
                                    onClick={() => openApprovalModal(item._id)} // Pass the ID to approve
                                    label="Approve"
                                    style={{ padding: '5px 10px', minWidth: 'auto' }} // Adjust padding for horizontal size
                                  />
                                  )}
                                </td> */}
                                <td className="switchmain">
                                  {/* {item.approved ? ( // Check if the item is approved */}
                                    {item.status ? (
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={true}
                                          onChange={(e) => {
                                            handleUserStatus({
                                              cp_id: item._id,
                                              status: 2,
                                              login_id: item?.login_id
                                            });
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    ) : (
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={false}
                                          onChange={(e) => {
                                            handleUserStatus({
                                              cp_id: item._id,
                                              status: 1,
                                              login_id: item?.login_id
                                            });
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    )}
                                  {/* ) : (
                                    // If not approved, show a message instead of the switch
                                    <span style={{ color: "grey" }}></span>
                                  )} */}
                                </td>
                                {view && (
                                  <td className="p-2">
                                    <i
                                      className="fa fa-eye theme-fa-icon mr-3"
                                      aria-hidden="true"
                                      title="View CP Agent"
                                      onClick={() => {
                                        // Navigate based on isAdmin and the respective ID
                                        const navigateTo = isAdmin ? `/view_cpAgent/${item._id}` : `/view_cpAgent/${item.cp_id}`;
                                        navigatpage(navigateTo); // Navigate to the correct page
                                      }}
                                    ></i>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={getchannelPartnerList} />
                  </div>
                  <Pagination
                    totalCount={
                      channelPartnerListSelector?.response?.total_data
                    }
                    listData={getchannelPartnerList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div
          className="modal fade show"
          style={{ display: 'block', backdropFilter: 'blur(5px)' }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="approveModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="approveModalLabel">Confirm Approval</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalOpen(false)}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <h6>Are you sure you want to approve this agent?</h6>
                </div>
              </div>
              <div className="modal-footer justify-content-center">
              <button
                  className="btn btn-success"
                  type="button"
                  onClick={() => handleApprove(selectedItemId)}
                  data-dismiss="modal"
                >
                  Approve
                </button>
                <button
                  className="btn btn-primary "
                  type="button"
                  onClick={() => setModalOpen(false)}
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AgentList;
